import { Link } from 'react-router-dom';
import PageHero from '../components/ui/PageHero';
import Reveal from '../components/ui/Reveal';
import RailwayTrack from '../components/ui/RailwayTrack';
import { industries } from '../data/industries';
import './Industries.css';

export default function Industries() {
  return (
    <div className="industries-page">
      <PageHero
        eyebrow="Industries We Serve"
        title="Built around how field service actually gets done."
        body="Five industries, one shared problem: work happens on-site, and the office needs to schedule it, track it, and bill for it without chasing paper."
      />

      <div className="container industries-jump">
        {industries.map((ind) => (
          <a key={ind.id} href={`#${ind.id}`} className="jump-pill">
            <ind.icon size={16} strokeWidth={1.8} /> {ind.name}
          </a>
        ))}
      </div>

      {industries.map((ind, i) => (
        <section key={ind.id} id={ind.id} className={`section industry-section ${i % 2 === 1 ? 'industry-section-alt' : ''}`}>
          <div className="container">
            <Reveal className="industry-section-head">
              <span className="industry-section-icon"><ind.icon size={32} strokeWidth={1.6} /></span>
              <div>
                <span className="eyebrow">{ind.name}</span>
                <h2>{ind.tagline}</h2>
              </div>
            </Reveal>

            <div className="industry-columns">
              <Reveal as="div" stagger className="industry-pain">
                <h3>Where it breaks down today</h3>
                <div className="pain-list">
                  {ind.painPoints.map((p) => (
                    <div key={p} className="pain-item reveal-item">
                      <p>{p}</p>
                    </div>
                  ))}
                </div>
              </Reveal>

              <div className="industry-solution">
                <h3>How Tecnvirons helps</h3>
                <RailwayTrack
                  items={ind.howWeHelp.map((item) => ({ ...item, key: item.module }))}
                  renderItem={(item) => (
                    <div className="solution-item">
                      <span className="pill">{item.module}</span>
                      <p>{item.detail}</p>
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
        </section>
      ))}

      <section className="section cta-section">
        <div className="container">
          <Reveal className="cta-box card">
            <h2>Don’t see your exact trade listed?</h2>
            <p>The platform is built on the same modules underneath — appointments, workforce, customers, orders, and subscriptions apply to almost any field-service or maintenance business.</p>
            <div className="hero-actions center">
              <Link to="/contact" className="btn btn-primary">Talk to us</Link>
              <Link to="/platform" className="btn btn-secondary">See the platform</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
